import { useEffect, useRef, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { businessActions, generalSelectors, businessTypes } from 'Ducks';

const useServices = (props) => {
	const once = useRef(true);
	const dispatch = useDispatch();
	const businessId = useSelector((item) => item?.user?.selectedBusinessId);
	const businessList = useSelector((item) => item?.business?.list);
	const isLoading = useSelector((state) =>
		generalSelectors.selectApiLoadingStatus(
			state,
			businessTypes.BUSINESSITEM.REQUEST
		)
	);
	useEffect(() => {
		if (props?.dispatchBusiness && businessId && once.current === true) {
			dispatch(
				businessActions.getBusinessItemRequest({ businessId: businessId })
			);
			once.current = false;
		}
	}, [businessId, props?.dispatchBusiness, dispatch]);

	const returnBusiness = useCallback(() => {
		if (Array.isArray(businessList)) {
			return businessList?.[0]?.attributes;
		}
		return businessList?.attributes;
	}, [businessList]);

	const checkBusinessLine = () => {
		const businessLine_name = returnBusiness()?.business_line;
		if (businessLine_name === 'offcb') return 'offline_cash_back';
		return 'core';
	};

	const newUser = useMemo(() => {
		return returnBusiness()?.has_package || returnBusiness()?.has_pos
			? false
			: true;
	}, [returnBusiness]);

	return isLoading
		? {}
		: {
				hasService: returnBusiness()?.has_package && returnBusiness()?.has_pos,
				hasOne: returnBusiness()?.has_package || returnBusiness()?.has_pos,
				hasOnlyOne: returnBusiness()?.has_package || returnBusiness()?.has_pos,
				hasPackage: returnBusiness()?.has_package,
				hasPose: returnBusiness()?.has_pos,
				businessLine: checkBusinessLine(),
				newUser,
				business: returnBusiness(),
				businessId,
		  };
};

export default useServices;
